<template>
  <section class="section">
    <div class="container is-fluid">

      <div class="columns">
        <div class="column is-12">
          <KPISection />
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <MapView />
        </div>
        <div class="column is-6">
          <ProvinceChart />
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import KPISection from '@/components/KPISection.vue';
import MapView from '@/components/MapView.vue';
import ProvinceChart from '@/components/ProvinceChart.vue';

</script>
